import React, { useState, useRef } from 'react';
import { StyleSheet, View, TextInput, Animated, TouchableWithoutFeedback } from 'react-native';
import { Color, CommonProperties } from '../styles';
import { scale } from '../utils/scale.utils';
import Icon from './Icon';

const InputAnimated = ({ label, style, onChangeText, value, iconName, ...rest }) => {
  const animatedValue = useRef(new Animated.Value(0)).current;
  const [stop, setStop] = useState(false);
  const ref = useRef(null);

  const selectField = () => {
    setStop(true);
    Animated.timing(animatedValue, {
      toValue: 100,
      duration: 200,
      useNativeDriver: false,
    }).start(() => {
      setStop(false);
      ref.current.focus();
    });
  };

  const deselectField = () => {
    if (stop || value.length > 0) {
      return;
    }
    Animated.timing(animatedValue, {
      toValue: 0,
      duration: 200,
      useNativeDriver: false,
    }).start();
  };

  const onChange = (text) => {
    onChangeText(text);
  };

  const interpolatedLabelPosition = animatedValue.interpolate({
    inputRange: [0, 100],
    outputRange: [scale(14), 0],
  });
  const interpolatedLabelSize = animatedValue.interpolate({
    inputRange: [0, 100],
    outputRange: [scale(12), scale(9)],
  });
  const interpolatedLabelLeft = animatedValue.interpolate({
    inputRange: [0, 100],
    outputRange: [scale(36), scale(6)],
  });

  const onPress = () => {
    if (ref.current) {
      ref.current.focus();
    }
  };

  return (
    <TouchableWithoutFeedback onPress={onPress}>
      <View style={styles.container}>
        {iconName ? (
          <View
            style={{
              position: 'absolute',
              left: scale(12),
              top: 0,
              bottom: 0,
              justifyContent: 'center',
            }}
          >
            <Icon color={Color.primary} name={iconName} size={18} />
          </View>
        ) : null}
        <Animated.View style={[styles.textWrap, { top: interpolatedLabelPosition }]}>
          <Animated.Text
            style={[
              styles.text,
              {
                fontSize: interpolatedLabelSize,
                marginLeft: iconName ? interpolatedLabelLeft : 0,
              },
            ]}
          >
            {label}
          </Animated.Text>
        </Animated.View>
        <TextInput
          ref={ref}
          style={[styles.input, iconName ? styles.inputWithIcon : null, style]}
          onFocus={selectField}
          onBlur={deselectField}
          onChangeText={onChange}
          value={value}
          {...rest}
        />
      </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    ...CommonProperties.py2,
  },
  textWrap: {
    position: 'absolute',
    bottom: 0,
    left: scale(6),
    zIndex: 2,
  },
  text: {
    color: '#64696d',
    backgroundColor: Color.accent,
    ...CommonProperties.px2,
    ...CommonProperties.fontFamily,
  },
  input: {
    //minHeight: scale(36),
    borderColor: '#c9c9c9',
    borderWidth: scale(1),
    ...CommonProperties.borderRadius2,
    ...CommonProperties.p3,
    fontSize: scale(12),
  },
  inputWithIcon: {
    paddingLeft: 36,
  },
});

export default InputAnimated;
